const apiUrl 	    = require('@/apiUrl.js')
const axios 	    = require('axios')

module.exports.posPost = async (data) => {
    try {
        // window.console.log(data, 'handler')
        const response = await axios.post(apiUrl.telegrambot.posPost, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.champeiPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.champeiPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.amatakPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.amatakPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.totalPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.totalPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.madamnomPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.madamnomPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.asdaPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.asdaPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.klassyPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.klassyPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.noirPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.noirPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.ciaPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.ciaPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.benchPointCreate = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.benchPointCreate, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}
module.exports.nomBot = async function (data) {
    try {
        const response = await axios.post(apiUrl.telegrambot.nomBot, data)
        return response
    } catch (error) {
        window.console.error(error)
    }
}